// extracted by mini-css-extract-plugin
export default {"card":"TrackingStatCard_card__Rw6pn","iconWrapper":"TrackingStatCard_iconWrapper__IuCH-","label":"TrackingStatCard_label__S4hhl","value":"TrackingStatCard_value__xMw0r"};